import { AHIcon, Circle, TouchableBox } from "arkh";

import React from "react";

export function WidgetRemoveButton({
  onPress,
  padding,
}: {
  onPress(): void;
  padding: number;
}) {
  return (
    <TouchableBox
      onPress={onPress}
      style={{ position: "absolute", top: 0, left: 0, padding }}
      hitSlop={{ top: 5, bottom: 30, left: 0, right: 30 }}
    >
      <Circle borderColor="border-primary" color="negative" size="medium">
        <AHIcon type="minus" color="surface" size="medium" />
      </Circle>
    </TouchableBox>
  );
}
